import React from 'react';
import { DataPersistenceToggle } from '@/components/investments/DataPersistenceToggle';

interface StatusBarProps {
  persistDataPreference: boolean;
  setPersistDataPreference: (value: boolean) => void;
  isProcessing: boolean;
}

export function StatusBar({ persistDataPreference, setPersistDataPreference, isProcessing }: StatusBarProps) {
  return (
    <div className="pt-4 border-t">
      <DataPersistenceToggle
        initialValue={persistDataPreference}
        onChange={setPersistDataPreference}
        isLoading={isProcessing}
      />
    </div>
  );
}
